import { action as apiAction } from 'api/Api'
import { setColor } from '../redux/labels'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  id: number
  color: number
}

export default (payload: Payload) => async dispatch => {
  const { id, color } = payload

  const optimisticAction = optimisticDispatch(dispatch, setColor({
    labelId: id,
    color
  }))

  try {
    await apiAction('ChangeLabelColor', {
      id,
      color
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    throw error
  }
}
